import React from 'react';
import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import Logo from './Logo/Logo.js';
import Phone1 from './Phone/Phone1.js';
import Hiring from './Hiring.js';
import * as page from './enum.js';
import Offerings from './Offerings.js';
import Methodology from './Methodology.js';
import Python from './Python.js';
import Data_Science from './Data_Science.js';
import Machine from './Machine.js';
import Django from './Django.js';
import Matlab from './Matlab.js';


class App extends React.Component{
    constructor(props){
       super(props);
       this.state = {
            flag : page.Pages.Home,
            home_Check : false,
            Modal_Check : "",
            Modal_title : "Title",
            ws : 1300,
       }
    }

    componentDidMount(){
        var intervalId = setInterval(() => {
            var size = window.innerWidth;
            console.log("window ",size);
            this.setState({
                ...this.state,
                ws : size,
            })
        }, 1000);
     }

    Open_HR_Services = () => {
        this.setState({
            ...this.state,
            flag : page.Pages.Hr,
            home_Check : true,
        })
    }

    Open_Hiring = () => {
        this.setState({
            ...this.state,
            flag : page.Pages.Hiring,
            home_Check : true,
        })
    }

    Open_About = () => {
        this.setState({
            ...this.state,
            flag : page.Pages.About,
            home_Check : true,
        });
    }

    Open_Training = () => {
        this.setState({
            ...this.state,
            flag : page.Pages.Training,
            home_Check : true,
        });
    }

    Open_Modal = (title) => {
        this.setState({
            ...this.state,
            Modal_title : title,
            Modal_Check : title,
        });
    }

    Check = () => {
        var Ch = this.state.flag;
        if(Ch === page.Pages.About){
            return (
                <div>
                    <div class="ml-4"><strong> About Us </strong></div>
                                <p id="Me" class="mt-2 ml-4 mr-4">Contrary to popular belief, Lorem Ipsum is not simply random text.
                                It has roots in a piece of classical Latin literature from 45 BC,
                                 making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in
                                  Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage,
                                  and going through the cites of the word in classical literature, discovered the undoubtable source.
                                  Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum"
                                  (The Extremes of Good and Evil) by Cicero, written in 45 BC.
                                  This book is a treatise on the theory of ethics, very popular
                                during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..",
                                 comes from a line in section 1.10.32.
                    </p>
                </div>
            );
        }else if(Ch === page.Pages.Hr){
            return (
                <div>
                    <div id="About" class="ml-4"><strong> HR Services- </strong></div>
                                <p id="Me" class="mt-2 ml-4 mr-4">Contrary to popular belief, Lorem Ipsum is not simply random text.
                                It has roots in a piece of classical Latin literature from 45 BC,
                                 making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in
                                  Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage,
                                  and going through the cites of the word in classical literature, discovered the undoubtable source.
                    </p>
                                        <div class="d-flex justify-content-around" id="Align_End">
                                        <div id="Content_Box" data-toggle="modal" data-target=".bd-example-modal-lg"
                                                onClick={this.Open_Modal.bind(this,"Offerings")}>
                                            <p id="Content_color_offer"><strong>Offering</strong></p>
                                        </div>
                                        <div id="Content_Box" data-toggle="modal" data-target=".bd-example-modal-lg"
                                                onClick={this.Open_Modal.bind(this,"Methdology")}>
                                            <p id="Content_color"><strong>Methodology</strong></p>
                                        </div>
                                 </div>
                </div>
            );
        }else if(Ch === page.Pages.Hiring){
            return (
                <div>
                <div id="Hiring" class="ml-4 mb-2"><strong>Hiring-</strong></div>
                <div id="Scroll">
                    <Hiring />
                </div>
                </div>
            );
        }else if(Ch === page.Pages.Training){
            return (
                <div>
                    <div id="About" class="ml-4"><strong> Training- </strong></div>
                                <p id="Me" class="mt-2 ml-4 mr-4">Contrary to popular belief, Lorem Ipsum is not simply random text.
                                It has roots in a piece of classical Latin literature from 45 BC,
                                 making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in
                                  Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage,
                                  and going through the cites of the word in classical literature, discovered the undoubtable source.
                    </p>
                    <div class="d-flex justify-content-around">
                          <div id="Content_Box" data-toggle="modal" data-target=".bd-example-modal-lg"
                                onClick={this.Open_Modal.bind(this,"Python")}>
                               <p id="Content_color_offer"><strong>Python</strong></p>
                          </div>
                          <div id="Content_Box" data-toggle="modal" data-target=".bd-example-modal-lg"
                                onClick={this.Open_Modal.bind(this,"Data Science")}>
                               <p id="Content_color"><strong>Data Science</strong></p>
                          </div>
                          <div id="Content_Box" class="mr-3" data-toggle="modal" data-target=".bd-example-modal-lg"
                                onClick={this.Open_Modal.bind(this,"Machine Learning")}>
                               <p id="Content_color"><strong>Machine Learning</strong></p>
                          </div>
                    </div>
                    <div class="d-flex justify-content-center mt-4">
                        <div id="Content_Box" class="mr-5"  data-toggle="modal" data-target=".bd-example-modal-lg"
                                onClick={this.Open_Modal.bind(this,"Django")}>
                               <p id="Content_color"><strong>Django</strong></p>
                          </div>
                          <div id="Content_Box" data-toggle="modal" data-target=".bd-example-modal-lg"
                                onClick={this.Open_Modal.bind(this,"Matlab")}>
                               <p id="Content_color"><strong>Matlab</strong></p>
                          </div>
                    </div>
                </div>
            )
        }
    }

    Modal_Content = () => {
        var check = this.state.Modal_Check;
        if(check === "Offerings"){
            return (
                <div><Offerings /></div>
            )
        }else if(check === "Methdology"){
            return(
                <div><Methodology /></div>
            )
        }else if(check === "Python"){
            return(
                <div><Python /></div>
            )
        }else if(check === "Data Science"){
            return(
                <div><Data_Science /></div>
            )
        }else if(check === "Machine Learning"){
            return(
                <div><Machine /></div>
            )
        }else if(check === "Django"){
            return(
                <div><Django /></div>
            )
        }else if(check === "Matlab"){
            return(
                <div><Matlab /></div>
            )
        }
    }

    Check_for_Image = () => {
        var check = this.state.home_Check;
        if(check){
            return (
                <div class="card">
                    {this.Check()}
                </div>
            )
        }else{
            return (
                <div id="Home_Image_div"><img id="Person_Img" src="Home_Icon.png"/></div>
            )
        }

    }

    Check_for_Screen_size = () => {
        var check = this.state.ws;
        var Ch = this.state.flag;
        if(check < 490 ) {
            console.log("HELLLLLOOO");
            return <Phone1/>;
        }else{
            console.log("HELLLLLOO01");
            var title = this.state.Modal_title;
        return(
              <div id="bk-color">
              <div class="modal fade bd-example-modal-lg" id="exampleModal" tabindex="-1" role="dialog"
              aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header" id="Modal_Color">
        <h5 class="modal-title" id="exampleModalLabel">{title}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" id="Modal_Content_Background">
            {this.Modal_Content()}
      </div>
      <div class="modal-footer" id="Modal_Color">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
            <div class="container-fluid">
            <div class="row">
                  <div class="col">
                        <div id="Scimox_color"><strong>ScimoX</strong></div>
                        <div class="d-flex justify-content-center">
                            <div id="Home_Img"><Logo/></div>
                        </div>

                  </div>
                  <div class="col">
                    <div id="Shift_right">
                      <ul>
                        <li onClick={this.Open_HR_Services}><p id="Header-text-color">
                        <strong>HR Services</strong></p></li>
                        <li onClick={this.Open_Hiring}><p id="Header-text-color">
                        <strong>Our Hiring</strong></p></li>
                        <li onClick={this.Open_Training} class="mt-4"><p id="Header-text-color">
                        <strong>Training Programs</strong></p></li>
                      </ul>
                    </div>
                      <div>
                            {this.Check_for_Image()}
                      </div>
                  </div>
            </div>
       </div>
           <div class="footer">
                <ul>
                        <li class="mr-5" ><p id="Footer-text-color">Contact Us</p></li>
                        <li class="mr-5" onClick={this.Open_About}><p id="Footer-text-color">About Us</p></li>
                        <li class="mr-5"><p id="Footer-text-color">Need Support</p></li>
                 </ul>
                 <p id="Footer-text-color-1">2020 Explore the Possibilities with ScimoX. All rights reserved.</p>
            </div>
       </div>
        )
        }
    }

    render(){
        var title = this.state.Modal_title;
        return(
            <div>
                {this.Check_for_Screen_size()}
            </div>
        )
    }



}

export default App;

//
//<div id="bk-color">
//              <div class="modal fade bd-example-modal-lg" id="exampleModal" tabindex="-1" role="dialog"
//              aria-labelledby="myLargeModalLabel" aria-hidden="true">
//  <div class="modal-dialog modal-lg" role="document">
//    <div class="modal-content">
//      <div class="modal-header" id="Modal_Color">
//        <h5 class="modal-title" id="exampleModalLabel">{title}</h5>
//        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
//          <span aria-hidden="true">&times;</span>
//        </button>
//      </div>
//      <div class="modal-body" id="Modal_Content_Background">
//            {this.Modal_Content()}
//      </div>
//      <div class="modal-footer" id="Modal_Color">
//        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
//      </div>
//    </div>
//  </div>
//</div>
//            <div class="container-fluid">
//            <div class="row">
//                  <div class="col">
//                        <div id="Scimox_color"><strong>ScimoX</strong></div>
//                        <div id="Video_Align" class="text-center"><img id="Home_Img" src="Ellipse.png"/></div>
//                  </div>
//                  <div class="col">
//                    <div id="Shift_right">
//                      <ul>
//                        <li onClick={this.Open_HR_Services}><p id="Header-text-color">
//                        <strong>HR Services</strong></p></li>
//                        <li onClick={this.Open_Hiring}><p id="Header-text-color">
//                        <strong>Our Hiring</strong></p></li>
//                        <li onClick={this.Open_Training} class="mt-4"><p id="Header-text-color">
//                        <strong>Training Programs</strong></p></li>
//                      </ul>
//                    </div>
//                      <div>
//                            {this.Check_for_Screen_size()}
//                      </div>
//                  </div>
//            </div>
//       </div>
//
//            <div class="footer">
//                <ul>
//                        <li class="mr-5" ><p id="Footer-text-color">Contact Us</p></li>
//                        <li class="mr-5" onClick={this.Open_About}><p id="Footer-text-color">About Us</p></li>
//                        <li class="mr-5"><p id="Footer-text-color">Need Support</p></li>
//                 </ul>
//                 <p id="Footer-text-color-1">2020 Explore the Possibilities with ScimoX. All rights reserved.</p>
//            </div>
//       </div>

//<div class="footer">
//                <ul>
//                        <li class="mr-5" ><p id="Footer-text-color">Contact Us</p></li>
//                        <li class="mr-5" onClick={this.Open_About}><p id="Footer-text-color">About Us</p></li>
//                        <li><p id="Footer-text-color">Need Support</p></li>
//                 </ul>
//                 <p id="Footer-text-color-1">2020 Explore the Possibilities with ScimoX. All rights reserved.</p>
//            </div>

// <div class="d-flex justify-content-center align-items-end" id="footer_Me">
//                <div id="Footer-text-color" class="mr-5">Contact Us</div>
//                <div id="Footer-text-color" class="mr-5">About Us</div>
//                <div id="Footer-text-color">Need Support</div>
//            </div>
//            <div class="d-flex justify-content-center">
//                    <div id="Footer-text-color" class="mt-3">2020 Explore the Possibilities with ScimoX. All rights reserved.</div>
//            </div>





//<div id="Video_Align" class="text-center"><img id="Home_Img" src="Ellipse.png"/></div>
